import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tab-content"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = {
  key: 1,
  class: "tab-content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_CheckReversal = _resolveComponent("CheckReversal")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_CheckDoublonsWithAccountingItemImport = _resolveComponent("CheckDoublonsWithAccountingItemImport")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.stepOpener,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.stepOpener) = $event)),
              variant: "pills",
              density: "compact",
              class: "rounded",
              style: {"background":"#f4f4f4"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  value: "2",
                  "data-cy": "AccountingPeriodOpening-extournes"
                }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createTextVNode(" Extournes ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  value: "3",
                  "data-cy": "AccountingPeriodOpening-analyse"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Analyse des pièces hors FEC ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.stepOpener === '2')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_v_card, {
                    class: "elevation-0",
                    style: {"background":"transparent"}
                  }, {
                    default: _withCtx(() => [
                      (_ctx.accountingPeriods.length === 0)
                        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, "Pas d'exercices enregistrés"))
                        : (!_ctx.accountingPeriodPrevious)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "pa-2" }, "N-1 n'a pas été créé dans bobbee", -1)),
                              _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "pt-4 px-2 pb-2" }, "Si il existe, il faut :", -1)),
                              _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "pa-2" }, "- le créer", -1)),
                              _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "pa-2" }, " - importer le FEC (indispensable à la reprise automatique des AN) ", -1)),
                              _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "pa-2" }, "- le clôturer", -1))
                            ], 64))
                          : (_ctx.accountingPeriodPrevious && _ctx.accountingPeriodPrevious.closed)
                            ? (_openBlock(), _createBlock(_component_CheckReversal, {
                                key: 2,
                                companyId: _ctx.companyId,
                                accountingPeriod: _ctx.accountingPeriod,
                                accountingPeriodId: _ctx.accountingPeriodId
                              }, null, 8, ["companyId", "accountingPeriod", "accountingPeriodId"]))
                            : (_openBlock(), _createElementBlock("h1", _hoisted_3, "L'exercice N-1 n'est pas clôturé"))
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (_ctx.stepOpener === '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_v_card, {
                    class: "elevation-0",
                    style: {"background":"transparent"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "mb-1" }, " Liste des pièces hors FEC, sur la période liée à l'import FEC sélectionné ", -1)),
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CheckDoublonsWithAccountingItemImport, { companyId: _ctx.companyId }, null, 8, ["companyId"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}